import * as constants from './constants';
import * as actions from './actions';
import * as selectors from './selectors';
import reducer from './reducer';
import Settings from './components/Settings';


export default { 
    constants, reducer , actions, selectors,
    Settings 
}